module.exports = __webpack_public_path__ + "4466aeec3386b965a2329fdd2b2bbb47.ttf";